module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_7005.7417d500.png";